
export class HolidaysDto {
  holidayId?: number;
  holidayDate:Date;
  holidayName: string;
  status: boolean;
  createdAt : Date | any;
  createdUser : number;
  updatedAt : Date | any;
  updatedUser : number;
  versionFlag : number;
}

export const HolidaysDtoDefault : HolidaysDto = {
  holidayId: 0,
  holidayDate:new Date(),
  holidayName: "",
  status: true,
  createdAt : new Date() ,
  createdUser : 0,
  updatedAt : new Date() ,
  updatedUser : 0,
  versionFlag : 1

};

